<template>
<div >
  <div class="row">
        <div class="flex xs12 sm12 lg9">
          <h1>Perguntas</h1>
        </div>
        <div class="flex xs12 sm12 lg3">
          <va-button class="text-right" @click="abrirNovo()"  :color="BuNovo.color" :style="BuNovo"> {{ $t('Geral.Novo') }}</va-button>
        </div>
  </div>

  <div v-if="novo">

    

              <div class="row">

                 <div class="flex md12 sm12 xs12 lg8">
                     <va-input
                        label="Pregunta"
                        v-model="pergunta.titulo"
                        placeholder="Pregunta "
                        type="textarea"
                      />
                  </div>
                  <div class="flex lg4 md12 sm12 xs12">
                      <va-select
                        :label="$t('forms.selects.simple')"
                        v-model="disciplina"
                        textBy="nome"
                        :options="allDisciplinas"
                        placeholder="Tipo de Avaliacao"
                      />
                    </div>

              </div>
              
              <div class="row">
                 <div class="flex md12 sm12 xs12 lg12">
                  <input type="radio"  value="A" v-model="pergunta.resposta">
                  <label for="one"> A </label>
                  <input class="tamanho_imput" type="text"  value="" v-model="pergunta.a">
                  <br>
                  <input type="radio"  value="B" v-model="pergunta.resposta">
                  <label for="two"> B </label>
                  <input class="tamanho_imput" type="text"  value="" v-model="pergunta.b">
                  <br>
                  <input type="radio"  value="C" v-model="pergunta.resposta">
                  <label for="two"> C </label>
                  <input class="tamanho_imput" type="text"  value="" v-model="pergunta.c">
                  <br>
                  <input type="radio" value="D" v-model="pergunta.resposta">
                  <label for="two"> D </label>
                  <input class="tamanho_imput" type="text"  value="" v-model="pergunta.d">
                  <br>
                  <input type="radio"  value="E" v-model="pergunta.resposta">
                  <label for="two"> E </label>
                  <input class="tamanho_imput" type="text"  value="" v-model="pergunta.e">
                  <br>

                </div>
              </div>
              <div class="row">

                <div class="flex md3 sm12 xs12 text-center">
                    <va-button class="text-right"  v-on:click="salvar_pergunta()"  color="dark"> {{ $t('Geral.Salvar') }}</va-button>
                </div>
              </div>

  </div>

    <va-data-table
          :fields="fields"
          :data="allPerguntas"
          hoverable
          no-pagination
          >
              <template slot="marker" slot-scope="props">
                <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
              </template>

              <template slot="actions" slot-scope="props">
                <va-button flat small color="info" @click="abrirPerguntas(props.rowData)" class="ma-0">
                  {{ $t('tables.entrar') }}
                </va-button>

              </template>

        </va-data-table>

</div>

</template>

<script>
// import cursos from './Cursos'
import axios from 'axios'
export default {
  name: 'cursos',

  components: {

  },

  data () {
    return {
      picked: '',

      users: [],
      BuNovo: {
        color: 'success',
        'width': '100%',
      },
      disciplina:{
        id:''
      },
      pergunta: {
        titulo: '',
        a: '',
        b: '',
        c: '',
        d: '',
        e: '',
        resposta: '',
        disciplina_id:'',

      },
      novo: false,
     
      users: [],

    }
  },
  created () {
    this.all()
  },
  computed: {
    allPerguntas () {
      return this.$store.state.avaliacao.allPerguntas
    },
    allDisciplinas () {
      return this.$store.state.disciplinas.disciplinas
    },

    fields () {
      return [{
        name: '__slot:marker',
        width: '30px',
        dataClass: 'text-center',
      }, {
        name: 'nome',
        title: this.$t('tables.headings.name'),
      }, {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    },
  },

  methods: {
    all () {
      this.$store.dispatch('allPerguntas')
      this.$store.dispatch('allDisciplinas')
    
    },
    abrirNovo () {
      this.novo = !this.novo
    },

    async salvar_pergunta () {
      //  console.log(this.pergunta);
      let enviar={
        titulo: this.pergunta.titulo,
        a: this.pergunta.a,
        b: this.pergunta.b,
        c: this.pergunta.c,
        d: this.pergunta.d,
        e: this.pergunta.e,
        resposta: this.pergunta.resposta,
        disciplina_id: this.disciplina.id,

      }


     await this.$store.dispatch('addPergunta', enviar)
        .then(() => {
          console.log('certo')
        }).catch(() => {
          console.log('errado')
        })

      this.pergunta = {
        titulo: '',
        a: '',
        b: '',
        c: '',
        d: '',
        e: '',
        resposta: '',
        disciplina_id: '',
      }

      this.all()
    },

    abrirPerguntas (value) {
    //  this.$store.dispatch('setQuestionario', value)
     // this.$emit('trocar_component', 'perguntas')
    },

  },
}
</script>

<style lang="css">

.tamanho_imput
{
  width: 80%;
  height: 30px;
  margin-top: 5px;

}

</style>
